import React from 'react'
import Tr from 'translations/Translations';
import SearchIcon from '@material-ui/icons/Search'
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconSearchButton(
    {
        tooltip = Tr('search2'),
        ...props
    }) {

    return <WorkableIconButton
        tooltip={tooltip}
        Icon={SearchIcon}
        {...props}
    />
}

WorkableIconSearchButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.elementType]),
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconSearchButton;